import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { reduxForm, Form, Field } from 'redux-form';

import { TextField } from 'common/components/forms';
import { FormError } from 'common/components/layout';
import { updatePassword } from 'redux/clubSignup/actions';
import { asyncValidatePassword } from 'redux/customer/helpers';

import { validatePassword } from './validators';

class Account extends Component {
  handleSubmit = (form) => {
    const { props } = this;
    const data = transformData(form);
    data.clubId = props.club.id;
    const clubSignup = props.clubSignup.data;
    props.updatePassword(data, clubSignup);
  };

  handleBack = (e) => {
    e.preventDefault();
    const { props } = this;
    props.onEdit('billing');
  };

  render() {
    const { handleSubmit, form } = this.props;
    return (
      <Form
        onSubmit={handleSubmit(this.handleSubmit)}
        className="c7-form"
        method="post"
      >
        <FormError formName={form} />
        <h3>Account</h3>
        <p>Please add a password so you can access your account.</p>
        <Field
          name="password"
          label="Password"
          formType="password"
          component={TextField}
          required
        />
        <Field
          name="confirmPassword"
          label="Confirm Password"
          formType="password"
          component={TextField}
          required
        />
        <div className="c7-checkout__content__buttons">
          <button type="submit" className="c7-button">
            Continue to Payment Information
          </button>
          <a onClick={this.handleBack}>Return to billing information</a>
        </div>
      </Form>
    );
  }
}

const transformData = (values) => {
  const data = {
    password: values.password,
    confirmPassword: values.confirmPassword
  };
  return data;
};

const validate = (values) => {
  const errors = validatePassword(values);
  return errors;
};

const mapStateToProps = (state) => {
  const initialValues = state.clubSignup;
  return {
    initialValues,
    clubSignup: state.clubSignup
  };
};

const asyncValidate = (values) => {
  const { password } = values;
  return asyncValidatePassword(password).then((errors) => {
    if (errors) {
      throw errors;
    }
  });
};

Account = reduxForm({
  form: 'account',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate,
  asyncValidate,
  asyncBlurFields: ['password']
})(Account);

export default withRouter(
  connect(mapStateToProps, { updatePassword })(Account)
);
